export class CategoryRequest {
    page?: number;
    perPage?: number;
    order?: string;
    orderby?: string;
    slug?: string[];
}
